import React, { useState } from 'react'
import "./style.css"


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import {faFacebook} from '@fortawesome/free-brands-svg-icons';
import {faGithub} from '@fortawesome/free-brands-svg-icons';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import Modal from '../modal/Modal'


const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return ( 
    <footer className="footer">
        <div className="container">
          <div className="footer__wrapper">
            <ul className="social">
              <li className="social__item"><a href="https://www.instagram.com/pixelcraft.fi/?igsh=MWpqc2s3czFp
              OGsxeA%3D%3D" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li>
              <li className="social__item"><a href="https://github.com/maikamp-ven" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faGithub} /></a></li>
              <li className="social__item"><a href="https://www.facebook.com/profile.php?id=61567865667907&locale=fi_Fi" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook}/></a></li>
              <li className="social__item"><a href="https://wa.me/+358468130887" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faWhatsapp} /></a></li>
            </ul>
            
            <div className="copyright">
              <button className="footer__copyright" onClick={openModal}>
              Copyright © 2024 pixelCraft
            </button>
            </div>
          </div>
        </div>
        <Modal isOpen={isModalOpen} onClose={closeModal}/>
      </footer>
   );
}
 
export default Footer;